/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetOrderReportQuery } from '../../models/get-order-report-query';
import { GetOrderReportQueryResult } from '../../models/get-order-report-query-result';

export interface ApiNurseryManagerReportsGetOrdersReportPost$Plain$Params {
      body?: GetOrderReportQuery
}

export function apiNurseryManagerReportsGetOrdersReportPost$Plain(http: HttpClient, rootUrl: string, params?: ApiNurseryManagerReportsGetOrdersReportPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetOrderReportQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiNurseryManagerReportsGetOrdersReportPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetOrderReportQueryResult>;
    })
  );
}

apiNurseryManagerReportsGetOrdersReportPost$Plain.PATH = '/api/NurseryManager/Reports/GetOrdersReport';
